"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "24",
    viewBox: "0 0 18 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864 ",
    d: "M453.854,1059.148l0,0-2-2a.5.5,0,0,0-.354-.146h-13a.5.5,0,0,0-.354.146l-2,2v0a.552.552,0,0,0-.145.352v21a.5.5,0,0,0,.5.5H443v-4.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v4.5h6.5a.5.5,0,0,0,.5-.5v-21A.55.55,0,0,0,453.854,1059.148ZM442,1074h-4v-3h4Zm0-5h-4v-3h4Zm0-5h-4v-3h4Zm5,10h-4v-3h4Zm0-5h-4v-3h4Zm0-5h-4v-3h4Zm5,10h-4v-3h4Zm0-5h-4v-3h4Zm0-5h-4v-3h4Zm-14.293-5,1-1h12.586l1,1Z",
    transform: "translate(-436 -1057)"
  }));
};

exports["default"] = _default;